import { checked, warning } from "assets/icons";
import {
  AppTable,
  AppModal,
  FormInput,
  AppButton,
  FormSelect,
  SearchInput,
  Skeleton,
} from "components";
import { TableBodyContent } from "components/AppTable";
import Administrator from "components/Administrator";
import DashboardLayout from "layouts/DashboardLayout";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useSearchParams } from "react-router-dom";
import { ApiService } from "services";
import styled from "styled-components";
import moment from "moment";
import { Router } from "utils/route";
import InstitutionDetails from "components/InstitutionDetails";
import InstitutionUsers from "components/InstitutionUsers";
import InstitutionTransactions from "components/InstitutionTransactions";
import { AiOutlineArrowLeft } from "react-icons/ai";
import axios from "axios";
import Skeleton2 from "components/Skeleton2";
import { userData } from "utils/userData";
export default function Institutions() {
  const storedState = JSON.parse(
    localStorage.getItem("institution_page_state") || "{}"
  );
  const [step, setStep] = useState(0);
  const [step2, setStep2] = useState(0);
  const [step3, setStep3] = useState(0);
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal3, setModal3] = useState(false);
  const [loading, setLoading] = useState(false);

  const [searchInput, setSearchInput] = useState("");
  const [name, setName] = useState();
  const [code, setCode] = useState();
  const [code2, setCode2] = useState(storedState.code2);
  const [domain, setDomain] = useState();
  const [email, setEmail] = useState();
  const [institutionType, setInstitutionType] = useState();
  const [image, setImage] = useState();

  //eslint-disable-next-line
  const [configFilterRate, setConfigFilterRate] = useState();
  //eslint-disable-next-line
  const [configFilterTime, setConfigFilterTime] = useState();

  const [institutions, setInstitutions] = useState([]);

  const [institutionDetails, setInstitutionDetails] = useState(
    storedState.institutionDetails || false
  );

  const savedItems = JSON.parse(localStorage.getItem("sInst"));
  const createInstitution = async () => {
    setLoading(true);
    try {
      const data = await ApiService.createInstitution({
        code: code || savedItems?.code,
        name: name || savedItems?.code,
        domain: domain || savedItems?.domain,
        supportEmails: email ? email.split(",") : savedItems?.email?.split(","),
        institutionType: institutionType || savedItems?.institutionType,
        logo_id: image?.id || savedItems?.image?.image,
      });
      setStep(2);
      setLoading(false);
      getInstitutions(`?institutionType=${activeTab}`);
      console.log(data);
      localStorage.removeItem("sInst");
    } catch (err) {
      console.log(err);

      setLoading(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };

  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "multipart/form-data",
    },
  };
  console.log(image, "mee");
  const [imageLoading, setImageLoading] = useState(false);

  const uploadImage = async (img) => {
    setImageLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}account/institution/image/`,
        img,
        config
      )
      .then((res) => {
        console.log(res?.data, "mee");
        toast.success("Logo Uploaded!");
        setImageLoading(false);
        setImage(res?.data?.data);
      })
      .catch((err) => {
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
        setImageLoading(false);
      });
  };

  const editInstitution = async () => {
    console.log(email, "dsd");
    setLoading(true);
    try {
      const data = await ApiService.editInstitution(selected2?.id, {
        name: name || selected2?.name,
        type: institutionType || selected2?.institutionType,
        domain: domain || selected2?.domain,
        supportEmails:
          email === undefined
            ? null
            : email.split(",") || selected2?.supportEmails,
      });
      setStep2(2);
      setLoading(false);
      getInstitutions(`?institutionType=${activeTab}`);
      console.log(data);
    } catch (err) {
      console.log(err);
      setLoading(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };

  const emailTriggerInstitution = async () => {
    setLoading(true);
    try {
      const data = await ApiService.emailTrigger({
        institutionId: selected2?.id,
        approvalRate: configFilterRate,
        duration: configFilterTime,
      });
      setStep3(2);
      setLoading(false);
      getInstitutions(`?institutionType=${activeTab}`);
      console.log(data);
    } catch (err) {
      console.log(err);
      setLoading(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };

  const getInstitutions = async (activeTab) => {
    setLoading(true);

    try {
      const data = await ApiService.getInstitution(activeTab);
      console.log(data);
      setInstitutions(data?.data);
      setLoading(false);

      console.log(data);
    } catch (err) {
      console.log(err);
      setLoading(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };

  const [inst, setInst] = useState();
  const getInstitution = async (id) => {
    setLoading(true);

    try {
      const data = await ApiService.getInstitution(id);
      console.log(data, "inst");
      setViewAdmin(true);
      setInst(data);
      setLoading(false);
      console.log(data);
    } catch (err) {
      setLoading(false);
      console.log(err);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };
  const getInstitution2 = async (id) => {
    setLoading(true);

    try {
      const data = await ApiService.getInstitution(id);
      console.log(data, "inst");
      setViewInstitution(true);
      setInst(data);
      setLoading(false);
      console.log(data);
    } catch (err) {
      setLoading(false);
      console.log(err);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };



  const institutionTabs = [
    {
      title: "Bank Institutions",
      param: "bank",
      route: "/institutions?tab=bank",
    },
    {
      title: "Non Bank Institutions",
      param: "nonBank",
      route: "/institutions?tab=nonBank",
    },
  ];

  const { route } = Router();
  //eslint-disable-next-line
  const [viewAdmin, setViewAdmin] = useState(storedState.viewAdmin || false);
  const [viewInstitution, setViewInstitution] = useState(
    storedState.viewInstitution || false
  );
  const [viewTransactions, setViewTransactions] = useState(
    storedState.viewTransactions || false
  );
  const [selected, setSelected] = useState(storedState.selected);
  const [selected2, setSelected2] = useState(storedState.selected2);

  useEffect(() => {
    const state = {
      institutionDetails,
      code2,
      selected,
      selected2,
      viewAdmin,
      viewInstitution,
      viewTransactions,
    };
    localStorage.setItem("institution_page_state", JSON.stringify(state));
  }, [
    institutionDetails,
    code2,
    selected,
    selected2,
    viewAdmin,
    viewInstitution,
    viewTransactions,
  ]);

  useEffect(() => {
    setConfigFilterRate(selected2?.emailTrigger?.approvalRate);
    setConfigFilterTime(selected2?.emailTrigger?.duration);
    //eslint-disable-next-line
  }, [selected2]);



  console.log(selected);
  const [param] = useSearchParams();
  const activeTab = param.get("tab");
  useEffect(() => {
    route(`/institutions?tab=${institutionTabs[0].param}`);
    getInstitutions(`?institutionType=${activeTab}`);
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    getInstitutions(`?institutionType=${activeTab}`);
  }, [activeTab]);
  console.log(selected);

  const idin = selected2;

  console.log(idin, savedItems, "new");



  return (
    <div
      onClick={() => {
        setSelected("");
      }}
    >
      <DashboardLayout>
        {imageLoading && <Skeleton />}
        <>
          {viewInstitution && (
            <InstitutionUsers
              data={inst}
              closeInstitution={setViewInstitution}
            />
          )}
          {viewAdmin && (
            <Administrator data={inst} closeViewAdmin={setViewAdmin} />
          )}

          {!viewInstitution && (
            <>
              {!viewAdmin && (
                <>
                  {institutionDetails && (
                    <InstitutionDetails
                      id={selected2}
                      code={code2}
                      close={setInstitutionDetails}
                      showTransactions={setViewTransactions}
                    />
                  )}

                  {institutionDetails ? (
                    ""
                  ) : viewTransactions ? (
                    <>
                      <p
                        onClick={() => setViewTransactions(false)}
                        style={{
                          color: "#14A2FD",
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <AiOutlineArrowLeft
                          size={20}
                          style={{ marginRight: "10px" }}
                        />{" "}
                        Back
                      </p>
                      <InstitutionTransactions id={code2} />
                    </>
                  ) : (
                    <div>
                      <>
                        <AppTable
                          tableHeadLength="9"
                          titleB="Institutions"
                          btnTitle="New Institutions"
                          btnAction={() => {
                            setModal(true);
                            setStep(0);
                            setImage(savedItems?.image);
                          }}
                          columnWidth="160px"
                          tableHead={[
                            "institution name",
                            "institution CODE",
                            "institution contact email",
                            "institution domain",
                            "institution  users",
                            "DATE CREATED",
                            "ACTION",
                          ]}
                          param2={`institutionType=${activeTab}`}
                          tabs={institutionTabs}
                          loading={loading}
                          action={getInstitutions}
                          transactions={institutions}
                          searchInput={searchInput}
                          childrenHead={
                            <div>
                              <SearchInput
                                width="160%"
                                onChange={(e) => {
                                  getInstitutions(
                                    `?search=${e.target.value || ""
                                    }&institutionType=${activeTab}`
                                  );
                                  setSearchInput(e.target.value);
                                }}
                              />
                            </div>
                          }
                        >
                          <TableBodyContent>
                            {loading ? (
                              <div style={{ width: "80vw" }}>
                                <Skeleton2 height="500px" />
                              </div>
                            ) : (
                              institutions?.results
                                ?.filter(
                                  (x) => x?.institutionType === activeTab
                                )
                                ?.map((item, index) => {
                                  return (
                                    <div
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns: `repeat(9, 160px)`,
                                        alignItems: "center",
                                      }}
                                      className="table_body_item"
                                    >
                                      <div
                                        style={{
                                          cursor: "pointer",
                                          wordBreak: "break-word",
                                        }}
                                        className="insName"
                                        onClick={() => {
                                          setCode2(item?.code);
                                          setSelected(item?.id);
                                          setSelected2(item?.id);
                                          setInstitutionDetails(true);
                                        }}
                                      >
                                        {item?.name || "-"}
                                      </div>
                                      <div>{item?.code || "-"}</div>
                                      <div
                                        style={{
                                          wordBreak: "break-word",
                                        }}
                                        className="email"
                                      >
                                        {item?.supportEmails?.length &&
                                          `${item?.supportEmails?.[0]}`}
                                        {(item?.supportEmails?.length && (
                                          <span
                                            style={{ position: "absolute" }}
                                          >
                                            [ {item?.supportEmails?.join(", ")}]
                                          </span>
                                        )) ||
                                          "-"}{" "}
                                      </div>
                                      <div>{item?.domain || "-"}</div>
                                      <div>{item?.users?.length || "-"}</div>
                                      <div>
                                        {moment(item?.updatedOn)
                                          .subtract(1, "hours")
                                          .format("DD-MM-YYYY hh:mm")}
                                      </div>

                                      <ViewAdmin
                                        className="view_admin"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          //getInstitution(item?.id);
                                          if (item?.id === selected) {
                                            setSelected("");
                                          } else {
                                            setSelected(item?.id);
                                          }
                                          console.log(
                                            index + 1,
                                            institutions?.results?.filter(
                                              (x) =>
                                                x?.institutionType === activeTab
                                            )?.length
                                          );
                                        }}
                                      >
                                        View Administrators
                                        <svg
                                          style={{ marginLeft: "5px" }}
                                          width="13"
                                          height="9"
                                          viewBox="0 0 13 9"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M1.91 0.794922L6.5 5.37492L11.09 0.794922L12.5 2.20492L6.5 8.20492L0.5 2.20492L1.91 0.794922Z"
                                            fill="#1B59F8"
                                          />
                                        </svg>
                                        {item?.id === selected && (
                                          <div
                                            onClick={(e) => {
                                              e.stopPropagation();
                                            }}
                                            className="dropdown"
                                            style={{
                                              position: "absolute",
                                              top:
                                                institutions?.results?.filter(
                                                  (x) =>
                                                    x?.institutionType ===
                                                    activeTab
                                                ).length ===
                                                  index + 1 ||
                                                  institutions?.results?.filter(
                                                    (x) =>
                                                      x?.institutionType ===
                                                      activeTab
                                                  ).length ===
                                                  index + 2
                                                  ? "-280%"
                                                  : "130%",
                                            }}
                                          >
                                            <div className="title">
                                              Select Option
                                            </div>
                                            <div>
                                              <div
                                                className="item"
                                                onClick={() => {
                                                  getInstitution(item?.id);
                                                }}
                                              >
                                                View Administrators
                                              </div>
                                              <div
                                                onClick={() => {
                                                  getInstitution2(item?.id);
                                                }}
                                                className="item"
                                              >
                                                View Institution Users
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </ViewAdmin>

                                      <ViewAdmin
                                        onClick={() => {
                                          setCode2(item?.code);
                                          setViewTransactions(true);
                                        }}
                                        className="view_admin"
                                      >
                                        View Transactions
                                      </ViewAdmin>
                                      <div
                                        style={{
                                          display: "flex",
                                        }}
                                      >
                                        <svg
                                          onClick={() => {
                                            setModal2(true);
                                            setSelected2(item);
                                            setEmail(
                                              item?.supportEmails
                                                ? ""
                                                : item?.supportEmails?.join("")
                                            );
                                          }}
                                          style={{
                                            width: "20px",
                                            marginRight: "16px",
                                            cursor: "pointer",
                                          }}
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 24 24"
                                          id="edit"
                                        >
                                          <path d="M5,18H9.24a1,1,0,0,0,.71-.29l6.92-6.93h0L19.71,8a1,1,0,0,0,0-1.42L15.47,2.29a1,1,0,0,0-1.42,0L11.23,5.12h0L4.29,12.05a1,1,0,0,0-.29.71V17A1,1,0,0,0,5,18ZM14.76,4.41l2.83,2.83L16.17,8.66,13.34,5.83ZM6,13.17l5.93-5.93,2.83,2.83L8.83,16H6ZM21,20H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z"></path>
                                        </svg>

                                        <div
                                          onClick={() => {
                                            setModal3(true);
                                            setSelected2(item);
                                          }}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <g clip-path="url(#clip0_1312_5196)">
                                              <path
                                                d="M19.8162 16.0942C18.5562 15.0292 17.8337 13.4725 17.8337 11.8233V9.5C17.8337 6.5675 15.6553 4.14 12.8337 3.73333V2.83333C12.8337 2.3725 12.4603 2 12.0003 2C11.5403 2 11.167 2.3725 11.167 2.83333V3.73333C8.34449 4.14 6.16699 6.5675 6.16699 9.5V11.8233C6.16699 13.4725 5.44449 15.0292 4.17699 16.1008C3.85283 16.3783 3.66699 16.7817 3.66699 17.2083C3.66699 18.0125 4.32116 18.6667 5.12533 18.6667H18.8753C19.6795 18.6667 20.3337 18.0125 20.3337 17.2083C20.3337 16.7817 20.1478 16.3783 19.8162 16.0942Z"
                                                fill="#868FA0"
                                              />
                                              <path
                                                d="M12.0001 22C13.5093 22 14.7718 20.9242 15.0618 19.5H8.93848C9.22848 20.9242 10.491 22 12.0001 22Z"
                                                fill="#868FA0"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_1312_5196">
                                                <rect
                                                  width="20"
                                                  height="20"
                                                  fill="white"
                                                  transform="translate(2 2)"
                                                />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })
                            )}
                          </TableBodyContent>
                        </AppTable>
                      </>

                      {/* MODALS */}

                      {modal && (
                        <div>
                          {step === 0 && (
                            <AppModal
                              closeModal={() => {
                                setModal(false);
                                setCode();
                                setDomain();
                                setEmail();
                                setName();
                                setInstitutionType();
                                setImage();
                              }}
                              heading="Add New Institution"
                            >
                              <FormSelect
                                label="Select Institution Type*"
                                placeholder="Select Institution Type"
                                options={[
                                  { name: "Bank", value: "bank" },
                                  { name: "Non Bank", value: "nonBank" },
                                ]}
                                optionLabel="name"
                                optionValue="value"
                                onChange={(e) => {
                                  setInstitutionType(e.target.value);
                                }}
                                defaultValue={savedItems?.institutionType}
                              />
                              <FormInput
                                label="Institution Name *"
                                placeholder="Enter your Institution Name"
                                onChange={(e) => {
                                  setName(e.target.value);
                                }}
                                defaultValue={savedItems?.name}
                              />
                              <FormInput
                                label="Institution Domain *"
                                placeholder="Enter your Institution Domain"
                                onChange={(e) => {
                                  setDomain(e.target.value);
                                }}
                                defaultValue={savedItems?.domain}
                              />
                              <FormInput
                                label="Institution Contact Email(s) *"
                                placeholder="Separate Multiple Emails with a 'comma(,)'"
                                onChange={(e) => {
                                  setEmail(e.target.value);
                                }}
                                defaultValue={savedItems?.email}
                              />
                              <FormInput
                                label="Institution Code *"
                                placeholder="Enter your Institution Code"
                                onChange={(e) => {
                                  setCode(e.target.value);
                                }}
                                defaultValue={savedItems?.code}
                              />

                              {image ? (
                                <div>
                                  <div
                                    style={{
                                      marginBottom: "10px",
                                    }}
                                  >
                                    Institution Logo
                                  </div>
                                  <div
                                    style={{
                                      marginBottom: "10px",
                                      padding: "10px",
                                      border: `1px solid #D0D5DD`,
                                      borderRadius: "6px",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <img
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "12px",
                                        objectFit: "cover",
                                      }}
                                      src={image?.image}
                                      alt=""
                                    />
                                    <svg
                                      onClick={() => {
                                        setImage();
                                      }}
                                      style={{
                                        height: "20px",
                                        width: "20px",
                                        cursor: "pointer",
                                      }}
                                      width="16"
                                      height="16"
                                      viewBox="0 0 16 16"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clip-path="url(#clip0_302_2)">
                                        <path
                                          d="M12.6415 1.91693H10.151C10.0267 0.839618 9.11012 0 8 0C6.88992 0 5.97346 0.839585 5.84922 1.91693H3.35855C2.35065 1.91693 1.53076 2.73705 1.53076 3.74492V3.83871C1.53076 4.60891 2.01034 5.26814 2.68592 5.53675V14.172C2.68592 15.1799 3.5059 16 4.51374 16H11.4863C12.4942 16 13.3141 15.1799 13.3141 14.172V5.53678C13.9897 5.26814 14.4693 4.60891 14.4693 3.83874V3.74495C14.4693 2.73705 13.6493 1.91693 12.6415 1.91693ZM8 0.866913C8.63138 0.866913 9.15838 1.31946 9.27499 1.91693H6.72525C6.84183 1.31942 7.36886 0.866913 8 0.866913ZM12.4472 14.172C12.4472 14.7019 12.0161 15.1331 11.4863 15.1331H4.51371C3.98395 15.1331 3.5528 14.7019 3.5528 14.172V5.66669H12.4472V14.172ZM13.6024 3.83871C13.6024 4.36863 13.1712 4.79981 12.6415 4.79981H3.35855C2.8288 4.79981 2.39764 4.36863 2.39764 3.83871V3.74492C2.39764 3.215 2.8288 2.78381 3.35855 2.78381H12.6415C13.1712 2.78381 13.6024 3.215 13.6024 3.74492L13.6024 3.83871Z"
                                          fill="#FF0000"
                                          stroke="#FF0000"
                                        />
                                        <path
                                          d="M5.67612 14.0245C5.91551 14.0245 6.10956 13.8304 6.10956 13.5911V8.71063C6.10956 8.47131 5.91547 8.27716 5.67612 8.27716C5.43676 8.27716 5.24268 8.47131 5.24268 8.71063V13.5911C5.24264 13.8304 5.43673 14.0245 5.67612 14.0245Z"
                                          fill="#FF0000"
                                          stroke="#FF0000"
                                        />
                                        <path
                                          d="M7.99985 14.0245C8.23924 14.0245 8.43332 13.8304 8.43332 13.5911V8.71063C8.43332 8.47131 8.23917 8.27716 7.99985 8.27716C7.76049 8.27716 7.56641 8.47131 7.56641 8.71063V13.5911C7.56641 13.8304 7.76046 14.0245 7.99985 14.0245Z"
                                          fill="#FF0000"
                                          stroke="#FF0000"
                                        />
                                        <path
                                          d="M10.3241 14.0245C10.5635 14.0245 10.7575 13.8304 10.7575 13.5911V8.71063C10.7575 8.47131 10.5634 8.27716 10.3241 8.27716C10.0847 8.27716 9.89063 8.47131 9.89063 8.71063V13.5911C9.89059 13.8304 10.0847 14.0245 10.3241 14.0245Z"
                                          fill="#FF0000"
                                          stroke="#FF0000"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_302_2">
                                          <rect
                                            width="16"
                                            height="16"
                                            fill="white"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </div>
                                </div>
                              ) : (
                                <FormInput
                                  label="Institution Logo *"
                                  type="file"
                                  placeholder="Enter your Institution Name"
                                  onChange={(e) => {
                                    const formData = new FormData();
                                    formData.append(
                                      "image",
                                      e.target.files?.[0]
                                    );
                                    uploadImage(formData);
                                  }}
                                />
                              )}

                              <AppButton
                                onClick={() => {
                                  if (
                                    code &&
                                    name &&
                                    domain &&
                                    institutionType &&
                                    image
                                  ) {
                                    localStorage.setItem(
                                      "sInst",
                                      JSON.stringify({
                                        code: code,
                                        name: name,
                                        domain: domain,
                                        institutionType: institutionType,
                                        image: image,
                                        email: email,
                                      })
                                    );
                                    setStep(1);
                                  } else {
                                    if (savedItems) {
                                      setStep(1);
                                      localStorage.setItem(
                                        "sInst",
                                        JSON.stringify({
                                          code: code || savedItems?.code,
                                          name: name || savedItems?.name,
                                          domain: domain || savedItems?.domain,
                                          institutionType:
                                            institutionType ||
                                            savedItems?.institutionType,
                                          image: image || savedItems?.image,
                                          email: email || savedItems?.email,
                                        })
                                      );
                                    } else {
                                      toast.error("Some field(s) are empty.");
                                    }
                                  }
                                }}
                                placeholder="Proceed"
                              />
                            </AppModal>
                          )}
                          {step === 1 && (
                            <AppModal
                              closeModal={() => {
                                setImage();
                                setModal(false);
                                setCode();
                                setDomain();
                                setName();
                                setEmail();
                                setInstitutionType();
                                setStep(0);
                              }}
                            >
                              <div>
                                <img src={warning} alt="" />
                                <h3>Confirm Changes</h3>
                              </div>
                              <p style={{ margin: "30px 0" }}>
                                Are you sure you want to create this
                                Institution?
                              </p>
                              <div style={{ display: "flex" }}>
                                <AppButton
                                  onClick={() => {
                                    setImage();
                                    setStep(0);
                                    setCode();
                                    setEmail();

                                    setDomain();
                                    setName();
                                    setInstitutionType();
                                  }}
                                  outline
                                  placeholder="Cancel"
                                />
                                &nbsp; &nbsp; &nbsp; &nbsp;
                                <AppButton
                                  onClick={() => {
                                    createInstitution();
                                  }}
                                  placeholder="Confirm"
                                  loading={loading}
                                  disabled={loading}
                                />
                              </div>
                            </AppModal>
                          )}
                          {step === 2 && (
                            <AppModal
                              closeModal={() => {
                                setImage();
                                setModal(false);
                                setCode();
                                setDomain();
                                setEmail();
                                setName();
                                setInstitutionType();
                                setStep(0);
                              }}
                            >
                              <div>
                                <img src={checked} alt="" />
                                <h3>Changes saved</h3>
                              </div>
                              <p style={{ margin: "30px 0" }}>
                                Institution has been successfully created.
                              </p>
                            </AppModal>
                          )}
                        </div>
                      )}

                      {modal2 && (
                        <div>
                          {step2 === 0 && (
                            <AppModal
                              closeModal={() => {
                                setModal2(false);
                                setDomain();
                                setEmail();
                              }}
                              heading={`Edit ${selected2?.name}`}
                            >
                              {" "}
                              <FormSelect
                                label="Select Institution Type*"
                                value={selected2?.institutionType}
                                options={[
                                  { name: "Bank", value: "bank" },
                                  { name: "Non Bank", value: "nonBank" },
                                ]}
                                optionLabel="name"
                                optionValue="value"
                                onChange={(e) => {
                                  setInstitutionType(e.target.value);
                                }}
                                disabled={
                                  userData?.userDetail?.role !== "chiefAdmin"
                                }
                              />
                              <FormInput
                                label="Institution Name *"
                                placeholder="Enter your Institution Name"
                                onChange={(e) => {
                                  setName(e.target.value);
                                }}
                                defaultValue={selected2?.name}
                                disabled={
                                  userData?.userDetail?.role !== "chiefAdmin"
                                }
                              />
                              <FormInput
                                label="Institution Domain *"
                                placeholder="Enter your Institution Domain"
                                onChange={(e) => {
                                  setDomain(e.target.value);
                                }}
                                defaultValue={selected2?.domain}
                              />
                              <FormInput
                                label="Institution Contact Email(s) *"
                                placeholder="Separate Multiple Emails with a 'comma(,)'"
                                onChange={(e) => {
                                  setEmail(e.target.value);
                                }}
                                defaultValue={selected2?.supportEmails}
                              />
                              <FormInput
                                disabled
                                label="Institution Code *"
                                placeholder="Enter your Institution Code"
                                onChange={(e) => {
                                  setCode(e.target.value);
                                }}
                                defaultValue={selected2?.code}
                              />
                              <AppButton
                                onClick={() => {
                                  setStep2(1);
                                }}
                                placeholder="Proceed"
                              />
                            </AppModal>
                          )}
                          {step2 === 1 && (
                            <AppModal
                              closeModal={() => {
                                setModal2(false);
                                setDomain();
                                setEmail();

                                setStep2(0);
                              }}
                            >
                              <div>
                                <img src={warning} alt="" />
                                <h3>Confirm Changes</h3>
                              </div>
                              <p style={{ margin: "30px 0" }}>
                                Are you sure you want to edit {selected2?.name}?
                              </p>
                              <div style={{ display: "flex" }}>
                                <AppButton
                                  onClick={() => {
                                    setDomain();
                                    setModal2(false);
                                    setEmail();

                                    setStep2(0);
                                  }}
                                  outline
                                  placeholder="Cancel"
                                />
                                &nbsp; &nbsp; &nbsp; &nbsp;
                                <AppButton
                                  onClick={() => {
                                    editInstitution();
                                  }}
                                  placeholder="Confirm"
                                  loading={loading}
                                  disabled={loading}
                                />
                              </div>
                            </AppModal>
                          )}
                          {step2 === 2 && (
                            <AppModal
                              closeModal={() => {
                                setModal2(false);
                                setDomain();
                                setEmail();

                                setStep2(0);
                              }}
                            >
                              <div>
                                <img src={checked} alt="" />
                                <h3>Changes saved</h3>
                              </div>
                              <p style={{ margin: "30px 0" }}>
                                {selected2?.name} has been successfully updated.
                              </p>
                            </AppModal>
                          )}
                        </div>
                      )}

                      {modal3 && (
                        <div>
                          {step3 === 0 && (
                            <AppModal
                              maxWidth={"700px"}
                              closeModal={() => {
                                setConfigFilterRate();
                                setModal3(false);
                                setConfigFilterTime();
                                setStep3(0);
                              }}
                              headingSize="21px"
                              heading={
                                <>
                                  {" "}
                                  Configure Notification Trigger for
                                  <span style={{ color: "#608bf8" }}>
                                    {" " + selected2?.name}
                                  </span>
                                </>
                              }
                            >
                              <div
                                style={{
                                  color: "#888888",
                                  marginBottom: "16px",
                                }}
                              >
                                Set the criteria for downtime notification
                              </div>
                              <div>
                                <FormInput
                                  type="number"
                                  label="Filter by Approval Rate"
                                  placeholder="%"
                                  onChange={(e) => {
                                    setConfigFilterRate(e.target.value);
                                  }}
                                  defaultValue={
                                    selected2?.emailTrigger?.approvalRate
                                  }
                                />
                              </div>
                              <div>
                                <FormInput
                                  type="number"
                                  placeholder="Secs"
                                  label="Filter by Last"
                                  onChange={(e) => {
                                    setConfigFilterTime(e.target.value);
                                  }}
                                  defaultValue={
                                    selected2?.emailTrigger?.duration
                                  }
                                />
                              </div>
                              <AppButton
                                onClick={() => {
                                  if (configFilterRate && configFilterTime) {
                                    setStep3(1);
                                  } else {
                                    toast.error("Fill Configuration Fields");
                                  }
                                }}
                                placeholder={
                                  selected2?.emailTrigger
                                    ? "Reset Configuration"
                                    : "Set Configuration"
                                }
                              />
                              &nbsp; &nbsp;
                              <AppButton
                                onClick={() => {
                                  setModal3(false);
                                  setConfigFilterRate();
                                  setConfigFilterTime();
                                  setStep3(0);
                                }}
                                outline
                                placeholder="Cancel"
                              />
                            </AppModal>
                          )}
                          {step3 === 1 && (
                            <AppModal
                              closeModal={() => {
                                setModal3(false);
                                setConfigFilterRate();
                                setConfigFilterTime();
                                setStep3(0);
                              }}
                            >
                              <div>
                                <img src={warning} alt="" />
                                <h3>Confirm Changes</h3>
                              </div>
                              <p style={{ margin: "30px 0" }}>
                                Are you sure you want to set this configuration
                                for {selected2?.name}?
                              </p>
                              <div style={{ display: "flex" }}>
                                <AppButton
                                  onClick={() => {
                                    setModal3(false);
                                    setConfigFilterRate();
                                    setConfigFilterTime();
                                    setStep3(0);
                                  }}
                                  outline
                                  placeholder="Cancel"
                                />
                                &nbsp; &nbsp; &nbsp; &nbsp;
                                <AppButton
                                  onClick={() => {
                                    emailTriggerInstitution();
                                  }}
                                  placeholder="Confirm"
                                  loading={loading}
                                  disabled={loading}
                                />
                              </div>
                            </AppModal>
                          )}
                          {step3 === 2 && (
                            <AppModal
                              closeModal={() => {
                                setModal3(false);
                                setConfigFilterRate();
                                setConfigFilterTime();
                                setStep3(0);
                              }}
                            >
                              <div>
                                <img src={checked} alt="" />
                                <h3>Changes saved</h3>
                              </div>
                              <p style={{ margin: "30px 0" }}>
                                {selected2?.name} has been successfully
                                configured.
                              </p>
                            </AppModal>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </>
      </DashboardLayout>
    </div>
  );
}

const ViewAdmin = styled.div`
  background: #1b59f81c;
  color: #1b59f8;
  padding: 10px;
  border-radius: 6px;
  cursor: pointer;
  width: fit-content;
  display: flex;
  align-items: center;
  position: relative;
  font-size: 11px;

  .dropdown {
    position: absolute;
    border: 1px solid #e1e1e1;
    border-radius: 20px;
    right: 0;
    background-color: white;
    z-index: 100;
    padding: 6px 16px;
    width: 160%;
    text-transform: capitalize;
    font-size: 14px;
    z-index: 120;
    .title {
      color: #000000b2;
      font-weight: 600;
      border-bottom: 1px solid #0000001a;
      padding: 6px 4px;
    }

    .item {
      padding: 6px 4px;
      cursor: pointer;
      color: #000000;
      font-weight: 4300;
    }
  }
`;
